export default {
  validate (value, args) {
    const pattern = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/;

    return value.match(pattern);
  },
};
